import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { PlantillaNotificacionCorreoDto } from '../dto/plantilla-notificacion-correo/plantilla-notificacion-correo.dto';

@Injectable({
  providedIn: 'root',
})
export class PlantillasCorreoService {
  private apiUrl = `${environment.apiUrl}/plantillas`;

  constructor(private http: HttpClient) {}

  obtenerPlantillas(): Observable<PlantillaNotificacionCorreoDto[]> {
    return this.http.get<PlantillaNotificacionCorreoDto[]>(this.apiUrl);
  }

  actualizarPlantilla(id: number, cuerpoPlantilla: string): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}/cuerpo`, { cuerpoPlantilla });
  }
}
